import { CellContext } from "@tanstack/react-table";

import { Cell } from "src/base-components/Table";
import { AccessRequestInDB } from "src/clients/taktile-api";
import { ClampedContent } from "src/design-system/utils/ClampedContent";

export const AccessRequestReasonCell: React.FC<{
  info: CellContext<AccessRequestInDB, unknown>;
  value?: string | null;
}> = ({ info, value }) =>
  value ? (
    <Cell className="!h-auto py-2" info={info}>
      <div className="max-w-xs">
        <ClampedContent lines={3}>{value}</ClampedContent>
      </div>
    </Cell>
  ) : (
    <Cell info={info}>-</Cell>
  );
